
angular.module('languages', ['pascalprecht.translate', 'ngCookies', 'tmh.dynamicLocale', 'ui.bootstrap'])




	.config(function ($translateProvider, LOCALES) {
		$translateProvider.useStaticFilesLoader({
			prefix: LOCALES.dir + '/locale-',
			suffix: '.json'
		});
		$translateProvider.preferredLanguage(LOCALES.preferredLocale || 'en_US');// is applied on first load
		$translateProvider.useLocalStorage();// saves selected language to localStorage
		$translateProvider.useMissingTranslationHandlerLog();
		$translateProvider.useSanitizeValueStrategy(null);  // http://angular-translate.github.io/docs/#/guide/19_security
	})

	.config(function (tmhDynamicLocaleProvider) {
		tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
	})

	.service('LocaleService', function ($translate, LOCALES, $rootScope, $injector, $timeout) {
		'use strict';

		var localesObj = LOCALES.locales;

		var _LOCALES = Object.keys(localesObj);
		if (!_LOCALES || _LOCALES.length === 0) {
			console.log('There are no _LOCALES provided');
		}

		var _LOCALES_DISPLAY_NAMES = [];
		_LOCALES.forEach(function (locale) {
			_LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
		});

		$rootScope.currentLocale = $translate.use() || LOCALES.preferredLocale;
		var currentLocale = $translate.use() || LOCALES.preferredLocale;
		self.currentLocale = $translate.use() || LOCALES.preferredLocale;


		// check avaliable locales
		var checkLocaleIsValid = function (locale) {
			return _LOCALES.indexOf(locale) !== -1;
		};

    
		// set current locale
    		var setLocale = function (locale) {
			if (!checkLocaleIsValid(locale)) {
				console.log('Locale name "' + locale + '" is invalid');
				return false;
			}
			$rootScope.currentLocale = locale;
			self.currentLocale = locale;
			currentLocale = locale;

			// asking angular-translate to load and apply proper translations
			$translate.use(locale);
			if (window.moment) {
				window.moment.locale(locale.replace('/_.*/', ''));
			}
		
			return true;
    		};
    

		var onLocaleChange = function(currentLocale) {
			if ($injector.has('tmhDynamicLocale')) {
				var tmhDynamicLocale = $injector.get('tmhDynamicLocale');
				tmhDynamicLocale.set(currentLocale.replace('_', '-').toLowerCase());
			}
			if ($injector.has('uibDatepickerPopupConfig')) {
				var uibDatepickerPopupConfig = $injector.get('uibDatepickerPopupConfig');
				uibDatepickerPopupConfig.closeText = $translate.instant('Close');
				uibDatepickerPopupConfig.currentText = $translate.instant('Today');
				uibDatepickerPopupConfig.clearText = $translate.instant('Clear');
			}
		}
		onLocaleChange(currentLocale);
		$rootScope.$on('$translateChangeSuccess', function(event, current, previous) {
			// Language has changed
			onLocaleChange(current.language);
		});

		// on successful applying translations by angular-translate
		$rootScope.$on('$translateChangeSuccess', function (event, data) {
			document.documentElement.setAttribute('lang', data.language);
		});

		return {
		getLocale: function() {
			return currentLocale;
		},
		getLocaleCurrentOrProposed: function () {
			return $translate.use() || $translate.proposedLanguage();
		},
			getLocaleDisplayName: function () {
				return localesObj[currentLocale];
			},
			setLocaleByDisplayName: function (localeDisplayName) {
				if (setLocale(
					_LOCALES[_LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName)]
				))
					return true;
				else
					return false;
			},
			getLocalesDisplayNames: function () {
				return _LOCALES_DISPLAY_NAMES;
			}
		};
	})

	.controller('LanguageSelect', function (LocaleService, $rootScope) {
		this.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
	this.currentLocale = LocaleService.getLocale();
		this.localesDisplayNames = LocaleService.getLocalesDisplayNames();
		this.visible = this.localesDisplayNames && this.localesDisplayNames.length > 1;

		$rootScope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
	$rootScope.currentLocale = LocaleService.getLocale();
		//console.log(this.currentLocaleDisplayName);

		this.changeLanguage = function (locale) {
			LocaleService.setLocaleByDisplayName(locale);
			this.currentLocaleDisplayName = locale;
		this.currentLocale = LocaleService.getLocale();
			$rootScope.currentLocaleDisplayName = locale;
		$rootScope.currentLocale = LocaleService.getLocale();
		};
	})

	// translate string template, e.g: "{{Person}} > {{Custome r}}"
	.filter('tpltranslate', function ($translate) {
		return function (value) {
			var ret = "";
			if (!value) return ret;
			var parts = value.split(/({{[^}]+}})/)
			if (parts.length == 1 && parts[0][0] != '{') {
				return $translate.instant(parts[0])
			}
			for (var i = 0; i < parts.length; i++) {
				var part = parts[i];
				if (part.match(/^{{(.*)}}$/)) {
					ret += $translate.instant(part.replace(/^{{(.*)}}$/, '$1'))
				} else {
					ret += part;
				}
			}
			return ret;
		}
	})




